<div class="encabezado">
  <div class="col-4 getBack">
    <a routerLink="/settings" class="getBack">
      <span><i class="icon-chevron-left"></i>{{ "forms.buttons.back" | translate }}</span>
    </a>
  </div>
  <div>
    <h5 class="titulo1">
      {{ "notification_reminders.title" | translate }}
    </h5>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="btn-izq">
        <button class="btn btn-hover" type="button" (click)="toggleForm()">
          {{ "buttons.add+" | translate }} <i class="icon-plus"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="tabla">
    <div class="table-responsive-wrapper">
      <div class="table-scroll-inner">
        <table
          mat-table
          class="full-width-table"
          matSort
          [dataSource]="dataSource"
        >
          <!-- Title -->
          <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
              {{ "notification_reminders.fields.title" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              <strong>{{ row.title }}</strong>
              <br *ngIf="row.description" />
              <small *ngIf="row.description" class="text-muted">{{ row.description }}</small>
            </td>
          </ng-container>

          <!-- Channels -->
          <ng-container matColumnDef="channels">
            <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
              {{ "notification_reminders.fields.channels" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              <span *ngFor="let channel of row.channels" class="me-2">
                <i [class]="channel === 'email' ? 'icon-envelope' : 'icon-bell2'"></i>
                {{ "notification_reminders.channel_options." + channel | translate }}
              </span>
            </td>
          </ng-container>

          <!-- Target Users -->
          <ng-container matColumnDef="target_users">
            <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
              {{ "notification_reminders.fields.target_users" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              <span *ngFor="let user of row.target_users; let last = last">
                {{ user.name }}<span *ngIf="!last">, </span>
              </span>
            </td>
          </ng-container>

          <!-- Actions -->
          <ng-container matColumnDef="rowActions">
            <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
              {{ "inputs.actions" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              <i class="icon-pencil text-success icon-actions" (click)="editReminder(row.reference)"></i>
              <i class="icon-trash2 text-danger icon-actions" (click)="deleteReminder(row.reference)"></i>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </div>
    <!-- Card layout mobile -->
    <div class="cards-mobile-wrapper">
      <div *ngFor="let row of dataSource.data" class="settings-card" (click)="editReminder($any(row).reference)">
        <div class="card-header-row">
          <span class="card-name">{{ $any(row).title }}</span>
        </div>
        <div class="card-body-content">
          <span *ngIf="$any(row).description" class="card-detail">{{ $any(row).description }}</span>
          <span class="card-detail">
            <span *ngFor="let channel of $any(row).channels" class="me-2">
              <i [class]="channel === 'email' ? 'icon-envelope' : 'icon-bell2'"></i>
              {{ "notification_reminders.channel_options." + channel | translate }}
            </span>
          </span>
          <span *ngIf="$any(row).target_users?.length" class="card-detail">
            <i class="icon-users"></i>
            <span *ngFor="let user of $any(row).target_users; let last = last">{{ user.name }}<span *ngIf="!last">, </span></span>
          </span>
        </div>
        <div class="card-footer-row">
          <div class="card-actions">
            <i class="icon-pencil text-success icon-actions" (click)="editReminder($any(row).reference); $event.stopPropagation()"></i>
            <i class="icon-trash2 text-danger icon-actions" (click)="deleteReminder($any(row).reference); $event.stopPropagation()"></i>
          </div>
        </div>
      </div>
    </div>
    <mat-paginator
      #paginator
      [length]="totalRecords"
      [pageSize]="pageSize"
      [pageSizeOptions]="[10, 25, 50]"
      (page)="onPageChange($event)"
    >
    </mat-paginator>
  </div>
</div>

<div
  class="formulario-derecha-container"
  [ngClass]="{ 'mostrar-formulario': showForm }"
>
  <app-form-add-reminder
    [reminderData]="reminderData"
    (backButtonClick)="cerrarFormulario()"
    (saved)="refrescar()"
  ></app-form-add-reminder>
</div>
<div class="overlay" *ngIf="showForm"></div>
